import { createFileRoute } from '@tanstack/react-router'
import { LegacyMatchAliasRecovery } from '~/features/football-match-detail/football-match-detail'
import { loadLegacyMatchAliasRoute } from '~/features/football-match-detail/legacy-route-options'
import { handleLegacyMatchAliasRequest } from '~/features/football-match-detail/legacy-server-handler'

export const Route = createFileRoute('/$locale/radar/opportunities/$opportunityId')({
  server: {
    handlers: {
      GET: ({ request, params }) => handleLegacyMatchAliasRequest({
        request,
        sourceKind: 'opportunity',
        sourceId: params.opportunityId,
        locale: params.locale === 'zh-CN' ? 'zh-CN' : 'en',
      }),
    },
  },
  loader: ({ params, location }) => loadLegacyMatchAliasRoute({
    sourceKind: 'opportunity',
    sourceId: params.opportunityId,
    locale: params.locale === 'zh-CN' ? 'zh-CN' : 'en',
    location,
  }),
  component: LocalizedRadarOpportunityLegacyRoute,
  notFoundComponent: () => <LegacyMatchAliasRecovery locale="zh-CN" kind="not_found" />,
})

function LocalizedRadarOpportunityLegacyRoute() {
  const { locale } = Route.useParams()
  const state = Route.useLoaderData()
  return (
    <LegacyMatchAliasRecovery
      locale={locale === 'zh-CN' ? 'zh-CN' : 'en'}
      kind={state.kind}
    />
  )
}
